import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import styles from './MuseumContactBanner.module.scss'

export const MuseumContactBanner: FC = () => {
  const { t } = useTranslation('home')
  const { t: tFooter } = useTranslation('footer')

  return (
    <section className={ styles.museumContactBanner }>
      <div className={ styles.museumContactBanner__copy }>
        <p className={ styles.museumContactBanner__title }>
          { t('museum_contact_banner_title') }
        </p>

        <p className={ styles.museumContactBanner__subtitle }>
          { t('museum_contact_banner_subtitle') }
        </p>
      </div>

      <a
        className={ styles.museumContactBanner__cta }
        href="mailto:support@belegends.com"
        target="_blank"
        rel="noreferrer"
      >
        { tFooter('contact_link') }
      </a>
    </section>
  )
}
